/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicAssetFilterDomainConditionDto } from './PublicAssetFilterDomainConditionDto';
import type { PublicDomainContentDefinitionDto } from './PublicDomainContentDefinitionDto';
import type { PublicSourceFilterDomainConditionDto } from './PublicSourceFilterDomainConditionDto';
import type { PublicTagFilterDomainConditionDto } from './PublicTagFilterDomainConditionDto';

export type PublicDynamicDomainContentDefinitionDto = (PublicDomainContentDefinitionDto & {
    /**
     * List of the conditions defining content of the domain
     */
    conditions?: Array<(PublicAssetFilterDomainConditionDto | PublicSourceFilterDomainConditionDto | PublicTagFilterDomainConditionDto)>;
    /**
     * Logical operator to use between conditions
     */
    filterLogicalOperator?: PublicDynamicDomainContentDefinitionDto.filterLogicalOperator;
} & {
    /**
     * List of the conditions defining content of the domain
     */
    conditions: Array<(PublicAssetFilterDomainConditionDto | PublicSourceFilterDomainConditionDto | PublicTagFilterDomainConditionDto)>;
    /**
     * Logical operator to use between conditions
     */
    filterLogicalOperator: PublicDynamicDomainContentDefinitionDto.filterLogicalOperator;
});

export namespace PublicDynamicDomainContentDefinitionDto {

    /**
     * Logical operator to use between conditions
     */
    export enum filterLogicalOperator {
        AND = 'AND',
        OR = 'OR',
    }


}
